import React, { useState, useEffect, UrlField } from 'react';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import DataTable from 'react-data-table-component';
const utils = require('../components/utils');

const baseUrl = `${window.nobid_endpoint.substring(0, window.nobid_endpoint.indexOf('/console'))}/adstxt/carbon/status_summary?missing=true`;
const conditionalRowStyles = [
	{
			when: row => row?.status === 'critical',
			style: {color: 'red', backgroundColor: 'white'}
	},
	{
    when: row => row?.status === 'warning',
    style: {color: 'orange', backgroundColor: 'white'}
  },
];
const tableColumns = [
  { name: 'Site', selector: 'name', sortable: true, width: '30%', cell: row => <a href={`/#/sites/${row.code}/4`} style={{color: 'white'}} target="_blank">{row.name}</a> },
  { name: 'ID', selector: 'code', sortable: true },
  { name: 'Status', selector: 'status', sortable: true, cell: row => <span>{ row.adstxt_found ? 'found' : 'missing' }</span> },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span> },
  { name: '#Ad Requests', selector: 'ad_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.ad_requests) }</span> }
];
let tableData = [];
const AdstxtAnalysisComponent = ({params, parentLoading}) => {
  const [loading, setLoading] = useState(true);

  const updateState = (results) => {
    tableData = results;
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    let url = `${baseUrl}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (parentLoading) getData() }, [parentLoading]);
 
  return (
    <div style={{position: 'relative'}}>
      <div>
        <div style={{float: 'left', paddingRight: '10px', paddingBottom: '20px'}}>
        <Tooltip title={
        <React.Fragment>Missing ads.txt files detected</React.Fragment>
        }>
          <HelpIcon/>
        </Tooltip>
        </div>
        <div style={{float: 'left'}}>
          <span style={{fontSize: '22px'}}>Ads.txt Anomalies</span> <span style={{fontSize: '12px'}}>- based on weekly impressions</span>
        </div>
      </div>
      <DataTable
        noHeader={true}
        theme="dark"
        columns={tableColumns}
        data={tableData}
        progressPending={loading}
        conditionalRowStyles={conditionalRowStyles}
        noDataComponent=<div style={{fontSize: '12px'}}>No anomalies detected</div>
        pagination
        fixedHeader
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        dense
        highlightOnHover
      />
    </div>
  )
}

export default AdstxtAnalysisComponent;
